const { reload } = require('./actions')

function configureBrowserNavigation(store) {
  window.addEventListener('pageshow', event => {
    if (isBackForwardNavigation(event)) {
      store.dispatch(reload())
    }
  })
  window.addEventListener('popstate', () => {
    // This is necessary to prevent buggy "Back button" behavior when
    // navigating from a client-v2 endpoint back to a wiggin endpoint.
    // See: https://app.asana.com/0/102902769366319/762136202375174/f
    // This will likely need to be revised/removed as part of:
    // https://app.asana.com/0/102902769366319/681203866231475/f
    const { router } = store.getState()
    // Decode the pathnames to work-around encoding inconsistencies
    const routerPathname = decodeURIComponent(router.location.pathname)
    const documentPathname = decodeURIComponent(document.location.pathname)
    if (routerPathname !== documentPathname) {
      document.location.reload(true)
    }
  })
}

function isBackForwardNavigation(event) {
  if (typeof window.performance !== 'undefined') {
    const { type } = window.performance.navigation
    return type === PerformanceNavigation.TYPE_BACK_FORWARD
  }
  return event.persisted
}

module.exports = {
  configureBrowserNavigation
}
